/**
 * SearchBar.tsx — 关键词搜索框
 * 提交后跳转到首页并携带 ?q= 参数（HomePage 负责过滤与展示）。
 */
import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { trackEvent } from '../lib/analytics';
import { SearchIcon } from './Icons';

interface SearchBarProps {
  initialValue?: string;
  className?: string;
}

export default function SearchBar({ initialValue = '', className = '' }: SearchBarProps) {
  const [value, setValue] = useState(initialValue);
  const navigate = useNavigate();

  function handleSubmit(event: FormEvent<HTMLFormElement>): void {
    event.preventDefault();
    const q = value.trim();
    trackEvent('search', { query: q });
    navigate(q ? `/?q=${encodeURIComponent(q)}` : '/');
  }

  return (
    <form onSubmit={handleSubmit} className={`relative ${className}`} role="search">
      <input
        type="search"
        value={value}
        onChange={(event) => setValue(event.target.value)}
        placeholder="搜索 Prompt，例如：公众号标题…"
        className="w-full rounded-full border border-slate-200 bg-slate-50 py-2 pl-4 pr-10 text-sm text-slate-800 outline-none transition focus:border-indigo-400 focus:bg-white"
      />
      <button
        type="submit"
        aria-label="搜索"
        className="absolute right-2 top-1/2 -translate-y-1/2 rounded-full p-1.5 text-slate-400 transition hover:text-indigo-500"
      >
        <SearchIcon />
      </button>
    </form>
  );
}
